import React, { Component } from "react";
import styled from "styled-components";
import Typewriter from "typewriter-effect";

import "./TitleMessage.style.css";

const MyTitleMessage = styled.h1`
  position: absolute;
  width: 100%;
  top: 22rem;
  bottom: 13.5rem;
  z-index: 1;
  margin-top: -150px;
  text-align: center;
  strong {
    font-size: 1.25em;
  }
  div {
    text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
    font-weight: 900;
    letter-spacing: 7px;
    .main {
      font-size: 40px;
      ${"" /* color: ${(props) => props.theme.textColor}; */}
      color: #29335c;
    }
    .sub {
      font-size: 30px;
      color: #ffffff;
    }
  }
`;

const animation = () => {
  const logo = document.querySelectorAll("#logo path");

  for (let i = 0; i < logo.length; i++) {
    console.log(`Letter ${i} is ${logo[i].getTotalLength()}`);
  }
};

class TitleMessage extends Component {
  componentDidMount() {
    animation();
  }
  render() {
    return (
      <MyTitleMessage>
        <div className="titleMessage">
          <div className="heading">
            <div className="main text-center mb-3">
              WELCOME TO MY ONLINE HOME. I'M
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <span>
                <svg
                  id="logo"
                  max-width="537"
                  max-height="70"
                  viewBox="0 0 537 104"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M52.936 102L29.032 60.96H13.192V102H0.0880127V1.632H32.488C40.072 1.632 46.456 2.928 51.64 5.52C56.92 8.112 60.856 11.616 63.448 16.032C66.04 20.448 67.336 25.488 67.336 31.152C67.336 38.064 65.32 44.16 61.288 49.44C57.352 54.72 51.4 58.224 43.432 59.952L68.632 102H52.936ZM13.192 50.448H32.488C39.592 50.448 44.92 48.72 48.472 45.264C52.024 41.712 53.8 37.008 53.8 31.152C53.8 25.2 52.024 20.592 48.472 17.328C45.016 14.064 39.688 12.432 32.488 12.432H13.192V50.448Z"
                    stroke="#d90368"
                    strokeWidth="5"
                  />
                  <path
                    d="M147.025 79.68H103.249L95.1854 102H81.3614L117.649 2.208H132.769L168.913 102H155.089L147.025 79.68ZM143.281 69.024L125.137 18.336L106.993 69.024H143.281Z"
                    stroke="#d90368"
                    strokeWidth="5"
                  />
                  <path
                    d="M239.161 102L197.833 56.208V102H184.729V1.632H197.833V48.144L239.305 1.632H255.865L210.361 51.888L256.297 102H239.161Z"
                    stroke="#d90368"
                    strokeWidth="5"
                  />
                  <path
                    d="M302.756 103.008C296.132 103.008 290.18 101.856 284.9 99.552C279.716 97.152 275.636 93.888 272.66 89.76C269.684 85.536 268.148 80.688 268.052 75.216H282.02C282.5 79.92 284.42 83.904 287.78 87.168C291.236 90.336 296.228 91.92 302.756 91.92C308.996 91.92 313.892 90.384 317.444 87.312C321.092 84.144 322.916 80.112 322.916 75.216C322.916 71.376 321.86 68.256 319.748 65.856C317.636 63.456 314.996 61.632 311.828 60.384C308.66 59.136 304.388 57.792 299.012 56.352C292.388 54.624 287.06 52.896 283.028 51.168C279.092 49.44 275.684 46.752 272.804 43.104C270.02 39.36 268.628 34.368 268.628 28.128C268.628 22.656 270.02 17.808 272.804 13.584C275.588 9.36 279.476 6.09599 284.468 3.792C289.556 1.488 295.364 0.335999 301.892 0.335999C311.3 0.335999 318.98 2.688 324.932 7.392C330.98 12.096 334.388 18.336 335.156 26.112H320.756C320.276 22.272 318.26 18.912 314.708 16.032C311.156 13.056 306.452 11.568 300.596 11.568C295.124 11.568 290.66 13.008 287.204 15.888C283.748 18.672 282.02 22.608 282.02 27.696C282.02 31.344 283.028 34.32 285.044 36.624C287.156 38.928 289.7 40.704 292.676 41.952C295.748 43.104 300.02 44.448 305.492 45.984C312.116 47.808 317.444 49.632 321.476 51.456C325.508 53.184 328.964 55.92 331.844 59.664C334.724 63.312 336.164 68.304 336.164 74.64C336.164 79.536 334.868 84.144 332.276 88.464C329.684 92.784 325.844 96.288 320.756 98.976C315.668 101.664 309.668 103.008 302.756 103.008Z"
                    stroke="#d90368"
                    strokeWidth="5"
                  />
                  <path
                    d="M432.775 1.632V102H419.671V56.496H368.551V102H355.447V1.632H368.551V45.696H419.671V1.632H432.775Z"
                    stroke="#d90368"
                    strokeWidth="5"
                  />
                  <path
                    d="M514.479 79.68H470.703L462.638 102H448.815L485.103 2.208H500.223L536.367 102H522.542L514.479 79.68ZM510.734 69.024L492.591 18.336L474.447 69.024H510.734Z"
                    stroke="#d90368"
                    strokeWidth="5"
                  />
                </svg>
              </span>
            </div>
            <div className="sub">
              I LOVE TO
              <Typewriter
                options={{
                  strings: ["CODE", "READ", "WRITE", "LEARN", "TRAVEL"],
                  autoStart: true,
                  loop: true,
                  delay: 50,
                }}
              />
            </div>
          </div>
        </div>
      </MyTitleMessage>
    );
  }
}

export default TitleMessage;
